<template>
    <SeoText
        :content="gameDescription"
        :class="$style.seo_override"
        :videoData="videoData"
    />
</template>
<script lang="ts" setup>
import { computed } from 'vue'

import SeoText from '@/components/SeoText/SeoText.vue'
import { PLAYGAMA_VIDEO } from '@/constants/general'
import type { APIGameType } from '@/types'
import { getYoutubeEmbedLink } from '@/utils/helpers'

const props = defineProps<{
    game: APIGameType
}>()

const videoData = computed(() => {
    const youtubeLink = getYoutubeEmbedLink(props.game.youtube_video)
    if (youtubeLink) {
        return {
            videoType: 'youtube',
            videoUrl: youtubeLink,
        } as const
    }

    const videoMetadata = props.game.video_metadata[0]

    if (videoMetadata) {
        const { playgama_id, external_url } = videoMetadata
        return {
            videoType: 'player',
            videoUrl: playgama_id ? PLAYGAMA_VIDEO(playgama_id, 640).url : external_url,
            posterUrl: props.game.preview,
        } as const
    }

    return undefined
})

const gameDescription = computed(() => {
    let text
    if (props.game.seo_text) {
        text = `${props.game.seo_text}`
    } else {
        text = `${props.game.description}`
        if (props.game.how_to_play_text) {
            text += `\n\n\n\n${props.game.how_to_play_text}`
        }
    }

    return text
        .replace(/\n•(.+)/gm, '<li>$1</li>')
        .replace(/(<li>.+<\/li>)+/g, '<ul>$1</ul>')
        .replace(/<p><\/p>/g, '')
        .replace(/\n\n/g, '')
        .replace(/<(\/?)h1>/g, '<$1h2>')
})
</script>
<style module>
.seo_override {
    max-width: 920px;
}
</style>
